import { useQuery } from '@tanstack/react-query';
import { dashboardWidgetService } from '@services';

/** Query key of the signed-in user's Dashboard; invalidating it refreshes the page and the menu item. */
export const MY_DASHBOARD_KEY = ['my-dashboard'];

/**
 * The signed-in user's Dashboard: the widgets available to their roles, their placements and Division filter.
 * @param enabled - Only load once the user is signed in
 */
export const useMyDashboard = (enabled: boolean) =>
  useQuery({
    queryKey: MY_DASHBOARD_KEY,
    queryFn: () => dashboardWidgetService.getMyDashboard(),
    enabled,
    // The menu item and the page read the same Dashboard; one request serves both.
    staleTime: 30_000
  });
